// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8f6dfe75","465":"9e19f00e"}[chunkId] + ".chunk.js";
};